import contentQuery from './contentQuery'

export default contentQuery
